<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item>专属链接</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">专属链接</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="createDialog = true">新建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="活动名称"
                      prop="name_keyword">
          <el-input v-model.trim="query.name_keyword"
                    placeholder="请输入活动名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="活动状态"
                      prop="statuses">
          <el-select v-model="query.statuses"
                     clearable
                     @change="fetchList(true)"
                     placeholder="请选择活动状态"
                     style="width: 100%;">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">活动列表</h3>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           fixed="left"
                           align="center"></el-table-column>

          <el-table-column prop="name"
                           label="活动名称"
                           width="400"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="打开人数"
                           width="120"
                           align="center"
                           show-overflow-tooltip
                           prop="statistic_total_user_count">
          </el-table-column>
          <el-table-column prop="statistic_total_request_count"
                           label="打开次数"
                           width="120"
                           align="center"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="活动状态"
                           width="200"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '上线' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建人"
                           width="200"
                           align="center"
                           show-overflow-tooltip
                           prop="creator_admin_nickname">
          </el-table-column>
          <el-table-column label="创建时间"
                           align="center"
                           width="200">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           align="center"
                           width="200">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right"
                           label="操作"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handlePromotion(scope.row)">推广</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToLook(scope.row)">查看</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div class="action-wrap">
          <div>
            <el-button size="mini"
                       type="danger"
                       @click="handleToDeleteAll()">批量删除</el-button>
          </div>
        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <AddPromotion :isVisible="createDialog"
                  @close="createDialog=false"
                  @submit="fetchList" />
    <EditPromotion :content="editContent"
                   :isVisible="editDialog"
                   @close="editDialog=false"
                   @submit="fetchList" />
    <!-- 推广 -->
    <LookPromotion :isVisible="lookDialog"
                   :content="editContent"
                   @close="lookDialog=false"
                   @submit="fetchList" />
    <DetailPromtion :isVisible="detailDialog"
                    :content="editContent"
                    @close="detailDialog=false"
                    @submit="fetchList"> </DetailPromtion>
    <!-- <AddMiniprogram
      :isVisible="createDialog"
      @close="createDialog=false"
      @submit="fetchList"
    />
    <EditMiniprogram
      :content="editContent"
      :isVisible="editDialog"
      @close="editDialog=false"
      @submit="fetchList"
    /> -->
  </div>
</template>

<script>
import { promotionActivityList, promotionDetlete } from '@/api/promotion'
import AddPromotion from '@/components/dialog/promotion/AddPromotion'
import LookPromotion from '@/components/dialog/promotion/LookPromtion'
import EditPromotion from '@/components/dialog/promotion/EditPromotion'
import DetailPromtion from '@/components/dialog/promotion/DetailPromtion'
export default {
  components: {
    AddPromotion,
    LookPromotion,
    EditPromotion,
    DetailPromtion,
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        is_get_statistic: 1,
        statuses: '',
      },
      pageTotal: 10,
      results: [],
      filter: {
        status: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '上线',
          },
          {
            value: 0,
            label: '下线',
          },
        ],
      },
      createDialog: false,
      editDialog: false,
      lookDialog: false,
      detailDialog: false,
      editContent: {},
      chooseList: [],
    }
  },

  created() {
    this.fetchList()
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      promotionActivityList(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      // this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    handlePromotion(row) {
      this.lookDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleToLook(row) {
      this.detailDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleToEdit(row) {
      this.editDialog = true
      this.editContent = Object.assign({}, row)
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })
        promotionDetlete({ ids }).then((res) => {
          this.fetchList()
        })
      })
    },
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
</style>
